import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Poux = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.41 98.05">
  <G fill={color}>
    <Path d="M81.08,53.24l-14.96-4.12c-.07-.28-.16-.56-.28-.82-.73-2.57-1.7-4.95-2.9-7.1,8.25-5.28,12.34-13.23,11.85-23.27-.12-2.5-2.24-4.48-4.74-4.31-2.5.12-4.43,2.24-4.31,4.74.34,7.09-2.35,12.14-8.44,15.68-.13-.12-.26-.25-.4-.36,1.76-2.78,2.75-6.01,2.75-9.35,0-5.25-2.35-9.96-6.03-13.16l2.31-4.62c1.12-2.24.22-4.96-2.02-6.08-2.23-1.12-4.96-.22-6.08,2.02l-2.36,4.72c-1.06-.2-2.14-.32-3.25-.32s-2.2.12-3.25.32l-2.36-4.72c-1.12-2.24-3.85-3.14-6.08-2.02-2.24,1.12-3.14,3.84-2.02,6.08l2.31,4.62c-3.69,3.2-6.03,7.91-6.03,13.16,0,3.37.98,6.6,2.74,9.36-.14.12-.26.24-.4.36-6.1-3.55-8.8-8.6-8.46-15.69.12-2.5-1.81-4.62-4.31-4.74-2.53-.17-4.62,1.81-4.74,4.31-.49,10.05,3.61,18.01,11.87,23.28-1.19,2.15-2.16,4.52-2.89,7.08-.12.26-.22.54-.28.82l-14.99,4.12c-2.41.66-3.83,3.16-3.17,5.57.55,2.01,2.38,3.33,4.37,3.33.4,0,.8-.05,1.21-.16l11.33-3.12c0,.33-.04.66-.04.99,0,1.88.16,3.78.45,5.67.01.08.02.17.04.25.11.66.23,1.33.36,1.99-5.58,2.72-11.6,8.75-10.58,22.19.18,2.38,2.17,4.19,4.51,4.19.11,0,.23,0,.35-.01,2.5-.19,4.36-2.37,4.17-4.86-.56-7.43,1.55-10.93,4.29-12.72,5.03,11.99,14.36,21.51,21.59,21.51s16.54-9.51,21.58-21.49c2.73,1.8,4.83,5.3,4.27,12.71-.19,2.49,1.68,4.67,4.18,4.86.12,0,.23.01.35.01,2.35,0,4.33-1.81,4.51-4.19,1.02-13.42-4.98-19.46-10.55-22.18.14-.67.26-1.34.37-2.01.02-.07.02-.14.04-.22.29-1.9.45-3.8.45-5.7,0-.33-.03-.66-.04-.99l11.3,3.11c.4.11.81.16,1.21.16,1.99,0,3.81-1.32,4.37-3.33.66-2.41-.76-4.91-3.17-5.57ZM42.22,15.97c4.62,0,8.38,3.76,8.38,8.37,0,1.79-.58,3.53-1.63,4.95-2.13-.67-4.38-1.05-6.75-1.05s-4.62.38-6.75,1.05c-1.05-1.42-1.63-3.15-1.63-4.95,0-4.62,3.76-8.37,8.38-8.37ZM42.22,37.31c5.51,0,10.04,3.13,12.89,8.35h-25.78c2.85-5.21,7.38-8.35,12.89-8.35ZM42.22,88.99c-1.37-.03-3.9-1.93-6.57-5.06h13.13c-2.66,3.13-5.2,5.03-6.56,5.06ZM54.63,74.87h-24.82c-.85-1.75-1.59-3.61-2.19-5.55h29.2c-.6,1.94-1.34,3.79-2.19,5.55ZM58.33,60.26H26.11c0-.14-.02-.27-.02-.41,0-1.79.13-3.51.36-5.14h31.54c.23,1.63.36,3.35.36,5.14,0,.14-.02.27-.02.41Z"/>
  </G>
</Svg>
);
};

export default Poux;
